require([
	'jquery'
], function(
	$
	) {

	'use strict';

	if($('.section-introSlideAnimation').length > 0){



	}

});
define("root/Assets/Templates/Html/IntroSlideAnimation/Js/IntroSlideAnimation", function(){});

